export function GithubRepo() {
    return (
        <div className="" id="Repository">
            <div className="flex items-center">
                <span className="block mr-2 rounded-full w-2 h-5 bg-primary"></span>
                <h2 className="text-2xl font-semibold text-white">Github Repository</h2>
            </div>

            <div className="mt-8 mb-16">
                <div className="pl-3">
                    <span className="text-lg font-light text-white">Link naar </span>
                    <a className="text-lg font-light text-primary hover:underline" href="https://github.com/wvdelden99/Medialab_1" target="_blank" rel="noreferrer">
                        Github Repository</a>
                </div>
            </div>
        </div>
    );
}